export const defaultErrorMessages = {
  required: $localize`Dies ist ein Pflichtfeld.`,
};
